import { createComponent } from "../utils";
import { FaceList } from "../modules";

export default createComponent({
  name: "Extrusion",
  description: "Extrusion",
  group: "Surface",
  icon: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 474 474"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M473.74 307.19C473.603 306.327 473.432 305.471 473.224 304.62C473.158 304.456 473.096 304.296 473.021 304.136C472.986 304.057 472.994 303.975 472.959 303.897C472.478 303.311 472.033 302.694 471.619 302.057C471.49 301.917 471.353 301.796 471.209 301.667C470.916 301.421 470.6 301.202 470.271 301.003C470.006 300.764 469.725 300.542 469.428 300.347L276.468 203.863V110.715H315.933C318.995 110.711 321.78 108.941 323.081 106.168C324.378 103.394 323.96 100.121 321.999 97.7653L243.069 3.05032C242.909 2.85891 242.682 2.77298 242.51 2.6011C242.339 2.42923 242.253 2.20266 242.061 2.04251C241.819 1.89407 241.569 1.75735 241.311 1.63626C240.467 1.05423 239.51 0.655794 238.503 0.472164C237.514 0.269044 236.495 0.269044 235.507 0.472164C234.499 0.655754 233.542 1.05419 232.698 1.64016C232.44 1.75735 232.19 1.89408 231.948 2.04251C231.757 2.20267 231.671 2.42531 231.499 2.60109C231.327 2.77297 231.096 2.85889 230.936 3.0503L152.006 97.7693C150.049 100.121 149.627 103.394 150.928 106.168C152.229 108.941 155.01 110.711 158.073 110.715H197.538V203.863L4.57764 300.347C4.28076 300.542 3.99951 300.761 3.73779 300.999C3.40576 301.198 3.08935 301.421 2.79248 301.667C2.65186 301.796 2.51514 301.917 2.38232 302.058C2.06982 302.425 1.79249 302.823 1.55811 303.245C1.37452 303.452 1.20264 303.671 1.04639 303.897C1.00732 303.975 1.01904 304.061 0.97998 304.136C0.905762 304.3 0.843262 304.452 0.780762 304.62C0.636232 305.073 0.534668 305.538 0.472168 306.011C0.374512 306.397 0.3042 306.792 0.26123 307.19C0.257324 307.276 0.214355 307.347 0.214355 307.429V351.449C0.261229 351.82 0.335442 352.187 0.437012 352.546C0.487793 353.117 0.601069 353.679 0.772949 354.222C0.972169 354.675 1.21826 355.109 1.50342 355.515C1.7417 355.964 2.02685 356.382 2.35107 356.773C2.75341 357.164 3.19874 357.511 3.67528 357.808C3.95653 358.066 4.25731 358.3 4.57762 358.511L233.478 472.961C233.544 472.993 233.626 472.981 233.692 473.012C235.778 474.051 238.232 474.051 240.317 473.012C240.388 472.981 240.466 472.993 240.536 472.961L469.436 358.511C469.753 358.3 470.053 358.066 470.335 357.808C470.811 357.511 471.257 357.164 471.663 356.773C472.253 355.964 472.78 355.113 473.241 354.222C473.413 353.679 473.526 353.117 473.577 352.55C473.678 352.191 473.753 351.82 473.799 351.449V307.429C473.799 307.343 473.753 307.276 473.749 307.19L473.74 307.19ZM15.9901 320.202L229.1 426.752V453.119L15.9901 346.569V320.202ZM244.89 426.752L458 320.202V346.569L244.89 453.119V426.752ZM166.199 309.952C167.254 314.179 171.539 316.753 175.766 315.694C188.754 312.448 213.321 296.772 213.321 260.678V102.818C213.321 100.725 212.488 98.7168 211.008 97.2364C209.528 95.756 207.52 94.9239 205.426 94.9239H174.918L236.996 20.4319L299.078 94.9239H268.57C266.476 94.9239 264.468 95.7559 262.988 97.2364C261.508 98.7169 260.676 100.725 260.676 102.818V260.678C260.676 296.772 285.242 312.448 298.231 315.694C302.449 316.726 306.707 314.151 307.762 309.941C308.813 305.726 306.262 301.452 302.055 300.378C301.801 300.319 276.461 293.601 276.461 260.679V221.515L448.261 307.417L236.991 413.047L25.7207 307.417L197.521 221.515V260.679C197.521 293.191 172.919 300.117 171.931 300.378C169.9 300.886 168.153 302.179 167.075 303.976C165.997 305.773 165.677 307.921 166.189 309.952L166.199 309.952Z"
        fill="currentColor"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "curve",
      name: "Curve",
      type: "Curve",
    },
    {
      id: "vector",
      name: "Vector",
      type: "Vector",
    },
  ],
  outputs: [
    {
      id: "extrusion",
      name: "Brep",
      type: "FaceList",
      compute: ({ curve, vector = [0, 0, 1] }) => {
        if (curve && curve instanceof window.rhino.NurbsSurface) {
          const brep = window.rhino.Brep.createFromSurface(curve);

          const curveB = curve.duplicate();
          curveB.translate(vector);

          const edges = brep.edges();
          const faces = [curve, curveB];

          const faceList = new FaceList();
          faceList.push(curve);
          faceList.push(curveB);

          for (let i = 0; i < edges.count; i++) {
            const edge = edges.get(i).toNurbsCurve();

            const edgeB = edge.duplicate();
            edgeB.translate(vector);
            const face = new window.rhino.NurbsSurface.createRuledSurface(
              edge,
              edgeB
            );
            faces.push(face);
            faceList.push(face);
          }

          return faceList;
        }

        if (curve && curve instanceof window.rhino.NurbsCurve) {
          const curveB = curve.duplicate();
          curveB.translate(vector);
          return new window.rhino.NurbsSurface.createRuledSurface(
            curve,
            curveB
          );
        }
      },
    },
  ],
});
